import { TranslationLocalService } from 'gung-standard';
import seTranslations from '../i18n/se.json';
import enTranslations from '../i18n/en.json';
import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';

@Injectable()
export class ColmecTranslationLocalService extends TranslationLocalService {
  constructor(protected http: HttpClient, protected handler: HttpBackend) {
    super(http, handler);
  }

  protected async getCustTranslations(lang: string): Promise<any> {
    if (lang === 'se') {
      return seTranslations;
    }
    if (lang === 'en') {
      return enTranslations;
    }
    return {};
  }
}
